import { HttpInterceptorFn } from '@angular/common/http';

const WRITE_METHODS = new Set(['POST', 'PUT', 'PATCH']);

function createIdempotencyKey(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
}

export const idempotencyInterceptor: HttpInterceptorFn = (req, next) => {
  const env = (window as unknown as { __env__?: Record<string, string | undefined> }).__env__;
  const apiUrl = (env?.['apiUrl'] ?? env?.['COOASS_API_URL'] ?? '').trim();
  const isBackendRequest =
    req.url.startsWith('/api/v1/') ||
    req.url.includes('localhost') ||
    (!!apiUrl && req.url.startsWith(apiUrl));

  if (!isBackendRequest) {
    return next(req);
  }

  let headers = req.headers;

  if (WRITE_METHODS.has(req.method.toUpperCase()) && !headers.has('Idempotency-Key')) {
    headers = headers.set('Idempotency-Key', createIdempotencyKey());
  }

  return next(req.clone({ headers }));
};
